const CG = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'?%3e%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%2085.333%20513%20342'%3e%3crect%20y='85.331'%20fill='%23da1a35'%20width='513'%20height='342'/%3e%3cpolygon%20fill='%23009543'%20points='443.726,85.331%20102.4,426.657%200,426.657%200,85.331%20'/%3e%3cpolygon%20fill='%23fbde4a'%20points='500.124,85.331%20158.798,426.657%2011.876,426.657%20353.202,85.331%20'/%3e%3c/svg%3e";
export {
  CG as default
};
//# sourceMappingURL=CG.svg.es.js.map
